export const LangEnum = {
  EN_US: "en-US",
  HE_IL: "he-IL",
  // TR_TR: "tr-TR",
  // ID_ID: "id-ID",
  // VI_VN: "vi-VN",
  // TH_TH: "th-TH",
  // MS_MY: "ms-MY",
  // ZH_CN: "zh-CN",
  // ZH_TW: "zh-TW",
  FR_FR: "fr-FR",
  // ES_ES: "es-ES",
  // KO_KR: "ko-KR",
  // KM_KH: "km-KH",
  // AR_AE: "ar-AE",
  // IW_IL: "iw-IL",
  DE_DE: "de-DE",
  IT_IT: "it-IT",
};
export const LangSettingEnum = {
  FOLLOW_SYSTEM: "follow_system",
  EN: "en",
  HE: "he",
  // TR: "tr",
  // ID: "id",
  // MS: "ms",
  // ZH: "zh",
  // TW: "tw",
  // VI: "vi",
  // TH: "th",
  FR: "fr",
  // ES: "es",
  // KO: "ko",
  // KM: "km",
  // AR: "ar",
  // IW: "iw",
  DE: "de",
  IT: "it",
};

export const LANG_MAP_LANG_CODE = {
  en: LangEnum.EN_US,
  he: LangEnum.HE_IL,
  // tr: LangEnum.TR_TR,
  // id: LangEnum.ID_ID,
  // ms: LangEnum.MS_MY,
  // vi: LangEnum.VI_VN,
  // th: LangEnum.TH_TH,
  // zh: LangEnum.ZH_CN,
  // tw: LangEnum.ZH_TW,
  fr: LangEnum.FR_FR,
  // es: LangEnum.ES_ES,
  // ko: LangEnum.KO_KR,
  // km: LangEnum.KM_KH,
  // ar: LangEnum.AR_AE,
  // iw: LangEnum.IW_IL,
  de: LangEnum.DE_DE,
  it: LangEnum.IT_IT,
};
export const DEFAULT_LANG = LangEnum.EN_US;
